import { Metamodel } from 'app/model/base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { DataWarehouseTableDataset, UpdateMethod, UpdateMethodType } from 'shell-models-lib';
import { SqlDWSink } from './sqldw.copysink';
import {
    CopyMethodOptionValue,
    copyMethodOptionValues
} from 'app/shared/components/copy-method-setting/copy-method-setting.const';

@Metamodel.model({
    name: __IS_FABRIC_DPE__ ? adfModelTypeMap.DataWarehouse.copySinkType : adfModelTypeMap.Warehouse.copySinkType,
    display: [],
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(DataWarehouseTableDataset) }
})
export class DataWarehouseCopySink extends SqlDWSink {
    @Metamodel.attribute({
        templatable: true,
        association: 'COPY_METHOD',
        display: stringResources.CopyMethod_Label
    })
    public copyMethod?: CopyMethodOptionValue = copyMethodOptionValues.BulkInsert as CopyMethodOptionValue;

    public get updateMethod(): UpdateMethodType {
        switch (this.copyMethod) {
            case copyMethodOptionValues.Upsert:
                return UpdateMethod.Upsert;
            case copyMethodOptionValues.BulkInsert:
                return UpdateMethod.Append;
            case copyMethodOptionValues.SCD2:
                return UpdateMethod.SCD2;
            default:
                return undefined;
        }
    }

    public set updateMethod(value: UpdateMethodType) {
        switch (value) {
            case UpdateMethod.Append:
                this.copyMethod = copyMethodOptionValues.BulkInsert as CopyMethodOptionValue;
                break;
            case UpdateMethod.Upsert:
                this.copyMethod = copyMethodOptionValues.Upsert as CopyMethodOptionValue;
                break;
            case UpdateMethod.SCD2:
                this.copyMethod = copyMethodOptionValues.SCD2 as CopyMethodOptionValue;
                break;
            default:
        }
    }
}
